import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Collection.js";
import "../../core/accessorSupport/watch.js";
import { autorun as r } from "../../core/accessorSupport/trackingUtils.js";
var t = new e(),
    n = new WeakMap();

function o(e) {
  c(e) && t.push(e);
}

function s(e) {
  c(e) && t.includes(e) && t.remove(e);
}

function c(e) {
  return e && "object" == typeof e && "refreshInterval" in e && "refresh" in e;
}

function f(e, r) {
  return Number.isFinite(e) && Number.isFinite(r) ? r <= 0 ? e : f(r, e % r) : 0;
}

var i = 0,
    a = 0;

function l() {
  var e = Date.now();

  var _iterator = _createForOfIteratorHelper(t),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _o = _step.value;

      if (_o.refreshInterval) {
        var r;
        e - (null != (r = n.get(_o)) ? r : 0) + 5 >= 6e4 * _o.refreshInterval && (n.set(_o, e), _o.refresh(e));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

r(function () {
  var e = Date.now();
  var r = 0;

  var _iterator2 = _createForOfIteratorHelper(t),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _o2 = _step2.value;
      r = f(Math.round(6e4 * _o2.refreshInterval), r), _o2.refreshInterval ? n.get(_o2) || n.set(_o2, e) : n.delete(_o2);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (r !== a) {
    if (a = r, clearInterval(i), 0 === a) return void (i = 0);
    i = setInterval(l, a);
  }
});
var u = {
  get hasRefreshTimer() {
    return i > 0;
  },

  get tickInterval() {
    return a;
  },

  forceRefresh: function forceRefresh() {
    l();
  },
  hasLayer: function hasLayer(e) {
    return c(e) && t.includes(e);
  },
  clear: function clear() {
    var _iterator3 = _createForOfIteratorHelper(t),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _e = _step3.value;
        n.delete(_e);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    t.removeAll();
  }
};
export { o as registerLayer, u as test, s as unregisterLayer };